import React, { useState } from "react";
import cx from "classnames";
import st from "./index.module.scss";
import SliderTextButton from "./SliderTextButton";
import VideoCover from "./VideoCover";
import { InternalPromotionalAnalyticRecord } from "services/datocms/generated";
import { Product } from "@pepdirect/shared/types";
import { useScreenSize } from "@pepdirect/helpers/useScreenSize";

type Props = {
  backgroundImageUrl: string;
  mobileBackgroundImageUrl: string;
  subHeader: string;
  header: string;
  disclaimer?: string;
  textColor: string;
  primaryButton: {
    text: string;
    color: string;
    textColor: string;
    ctaUrl: string;
  };
  secondaryButton?: {
    text: string;
    color: string;
    textColor: string;
    ctaUrl: string;
  };
  imageUrl?: string;
  embedVideoUrl?: string;
  textPosition?: string;
  blanket?: {
    blanketType: string;
    gradientType: string;
  };
  internalPromotionAnalytics?: InternalPromotionalAnalyticRecord;
  primaryItem?: Product;
  secondaryItem?: Product;
};

export const HomepageHeroSlide = (props: Props) => {
  const { isSmallMobile } = useScreenSize();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false);
  const {
    backgroundImageUrl,
    mobileBackgroundImageUrl,
    subHeader,
    header,
    disclaimer,
    primaryButton,
    secondaryButton,
    imageUrl,
    textPosition,
    textColor,
    blanket,
    embedVideoUrl,
    internalPromotionAnalytics,
    primaryItem,
    secondaryItem,
  } = props;

  const isCenter = textPosition === "center";
  const isTextRight = textPosition === "right";
  const hideImage = isCenter || !imageUrl || embedVideoUrl;

  const blanketClasses: {
    [blanketType: string]: { [gradientType: string]: string };
  } = {
    light: {
      no_gradient: "lightBlanket",
      left_gradient: "leftLightGradient",
      right_gradient: "rightLightGradient",
    },
    dark: {
      no_gradient: "darkBlanket",
      left_gradient: "leftDarkGradient",
      right_gradient: "rightDarkGradient",
    },
  };
  const blanketClass = blanket
    ? blanketClasses[blanket.blanketType][blanket.gradientType]
    : "";

  const bgImageUrl = isSmallMobile
    ? mobileBackgroundImageUrl
    : backgroundImageUrl;

  return (
    <div
      className={cx(st.container, blanketClass && st[blanketClass])}
      style={{ backgroundImage: `url("${bgImageUrl}")` }}
    >
      <div
        className={cx(
          st.contentContainer,
          isCenter && st.center,
          isTextRight && st.rightText
        )}
      >
        <div className={cx(st.textButtonWrapper, isCenter && st.center)}>
          <SliderTextButton
            subHeader={subHeader}
            header={header}
            disclaimer={disclaimer}
            textColor={textColor}
            primaryButton={primaryButton}
            secondaryButton={secondaryButton}
            isCenter={isCenter}
            internalPromotionAnalytics={internalPromotionAnalytics || undefined}
            primaryItem={primaryItem}
            secondaryItem={secondaryItem}
          />
        </div>
        {!hideImage && (
          <div className={st.mediaContainer}>
            <div
              className={st.image}
              style={{ backgroundImage: `url("${imageUrl}")` }}
            />
          </div>
        )}
        {embedVideoUrl && (
          <div className={st.mediaContainer}>
            <VideoCover
              isVideoModalOpen={isVideoModalOpen}
              embedVideoUrl={embedVideoUrl}
              imageUrl={imageUrl || ""}
              openVideoModal={() => {
                setIsVideoModalOpen(true);
              }}
              closeVideoModal={() => {
                setIsVideoModalOpen(false);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
